import request from '@/utils/request'

/**
 * 获取额度分配管理列表
 * @param {*} data
 */

export const getNormalList = data =>
  request().post('creditLine/parent/amounts', data)

/**
 * 获取批量申请待审批列表
 * @param {*} data
 */
export const getBatchAuditList = data =>
  request().post('relation/batch/task/page', data)

/**
 * 获取企业列表
 * @param data
 * @returns {*}
 */
export const getCustomerList = data => request().get(`customer/list/${data}`)
// 审批
export const doApprove = data => request().post('relation/batch/approve', data)
/**
 * 下载附件
 * @param {*} data relation/batch/download
 */
export const downloadAttachment = id => {
  return request().get(`relation/batch/download/${id}`, {
    responseType: 'blob',
  })
}
// 获取集团审批信息relation/batch/task/detail/
export const getApplyList = bpmId =>
  request().get(`relation/batch/task/detail/${bpmId}`)
/**
 * 查看是否能申请
 * @param {*} data
 */
export const checkAllow = data => request().get(`bp/apply/checkAllow/${data}`)

/**
 * 获取子公司信息
 * @param {*} data
 */
export const getAllocateOverview = data =>
  request().post('creditLine/allocate/overview', data)

// ----------------------------限额分配管理页------------------------
/**
 * 限额分配管理页的提交
 * @param {*} data
 */
export const doAllocate = data =>
  request(false).post('creditLine/allocate', data)

/**
 * 限额分配管理页上传批量文件
 * @param {*} data
 */
export const uploadBatchAllocate = data =>
  request().post('creditLine/batchAllocate', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

/**
 * 限额分配管理页下载模板
 */
export const downloadAllocateTemp = () =>
  request().get('creditLine/allocate/template/pull', { responseType: 'blob' })

// ----------------------------限额分配记录页------------------------
/**
 * 获取限额分配记录列表
 * @param {*} data
 */
export const getRecordList = data => request().post('creditLine/page', data)

/**
 * 限额分配页取消授信
 * @param {*} id
 */
export const cancelAllocate = id =>
  request(false).get(`creditLine/allocate/cancel/${id}`)

// ----------------------------额度分配管理页------------------------
/**
 * 获取信控区列表
 */
export const getBusinessList = () => request().get('business/cca/list')
/**
 * 获取Segment列表
 */
export const getSegmentList = business =>
  request().post(`sysSegment/group/${business}`)
/**
 * 获取BG下拉列表
 */
export const getBgList = () => request().get('business/list')
//根据business查name
export const selectName = business =>
  request().post(`business/selectName/${business}`)
//根据segment查segmentLevel
export const selectLevel = segment =>
  request().post(`sysSegment/selectLevel/${segment}`)

/**
 * 额度分配管理页的提交
 * @param {*} data
 */
export const doLoanAllocate = data =>
  request(false).post('creditLine/loan/allocate', data)

/**
 * 额度分配管理页上传批量文件
 * @param {*} data
 */
export const uploadLoanBatchAllocate = data =>
  request().post('creditLine/loan/batchAllocate', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

/**
 * 额度分配管理页下载模板
 */
export const downloadLoanAllocateTemp = () =>
  request().get('creditLine/allocate/loan/template/pull', {
    responseType: 'blob',
  })

// ----------------------------额度分配记录页------------------------
/**
 * 获取额度分配记录列表
 * @param {*} data
 */
export const getRecordLoanList = data =>
  request().post('creditLine/loan/page', data)

/**
 * 额度分配记录页取消授信
 * @param {*} id
 */
export const cancelLoanAllocate = id =>
  request(false).get(`creditLine/loan/allocate/cancel/${id}`)

// ----------------------------集团关系管理页------------------------
/**
 * 获取集团关系列表
 * @param {*} data
 */
export const getRelationList = data => request().post('relation/page', data)

/**
 * 集团关系管理页取消绑定
 * @param {*} id
 */
export const cancelRelation = id =>
  request(false).get(`customer/relation/delete/${id}`)
//信用主管
export const getListCManager = () => request().get('bp/apply/listCManager')
/**
 * 集团关系管理页上传批量文件
 * @param {*} data
 */
export const uploadRelationBatch = data =>
  request().post('relation/batch/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
/**
 * 集团关系管理页取消批量文件
 * @param {*} data
 */
export const uploadCancelRelationBatch = data =>
  request().post('relation/batchUpload/disable', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
/**
 * 下载批量申请模板
 */
export const downloadTemp = () =>
  request().get('relation/template/pull', { responseType: 'blob' })
/**
 * 获取审批人列表/credit/assurance/apply/approves/relation/approver/{type}
 */
export const getApprovePersons = type =>
  request().get(`relation/approver/${type}`)
// apply批量发起申请
export const apply = data => request().post('relation/batch/apply', data)

/**
 * 下载批量文件
 * @param {*} id relation/batch/download/{id}
 */
export const downloadBatchFile = id =>
  request().get(`relation/batch/download/${id}`, { responseType: 'blob' })

/**
 * 获取信用主管审批人列表
 */
export const getManagerList = () => request().get('bp/apply/listCManager')

/**
 * 获取批量申请列表
 * @param {*} data relation/batch/upload/page
 */
export const getRelationBatchList = data =>
  request().post('relation/batch/upload/page', data)

/**
 * 集团关系管理页取消下载模板
 */
export const downloadCancelRelationTemp = () =>
  request().get('relation/template/disable/pull', { responseType: 'blob' })

/**
 * 集团关系管理页下载模板
 */
export const downloadRelationTemp = () =>
  request().get('customer/relation/template/pull', { responseType: 'blob' })

/**
 * 新增集团关系
 * @param {*} data
 */
export const addRelation = data => request().post('customer/relation/add', data)

// 申请文件下载
export const uploadFile = data => request().post('relation/upload', data)

/**
 * 附件删除文件
 * @param {*} id
 */
export const deleteFile = id => {
  return request().get(`bp/attachment/delete/${id}`)
}

// download导出
export const download = data =>
  request().post('creditLine/loan/export', data, {
    responseType: 'blob',
  })
// 集团关系导出
export const downloadgroup = data =>
  request().post('relation/export', data, {
    responseType: 'blob',
  })

// 获取标准账期
export const getPeriodist = data => request().post('accountPeriod/periodList', data)